import _ from 'lodash'
import { baseTheme } from './base'
import palette from './palette'
import {createTheme} from "@material-ui/core";

export const createPilotTheme = () => {
  return createTheme(_.merge({}, baseTheme, palette))
}